import { Environment } from './environment';

export const environmentProd: Environment = {
  referAndWinUrl: 'https://refiereygana.aptuno.com/',
  segmentAnalyticsApiKey: 'GZTUfKWFDhLvXBwf7x51nvf8YAT78HGa',
  decimalSeparator: ',',
  groupSeparator: '.',
  thousandSeparator: '.',
  urlLogin: '/ingreso',
  hotjarHJID: 1887152,
  hotjarHJSV: 6,
  sentryDNS:
    'https://58f497af6d754aaf9fa1ff8888869f54@o491496.ingest.sentry.io/6156180',
  gcpStorage: {
    baseUrl: 'https://storage.googleapis.com/aptuno-assets',
    cdnBaseUrl: 'https://cdn.aptuno.com',
  },
  plans: {
    aptunoBrokerage: {
      friendlyName: 'Corretaje Aptuno',
      includes: [
        {
          text: '<strong>Publicación</strong> en Aptuno y en portales aliados',
          icon: 'plus',
        },
        {
          text: '<strong>Búsqueda del inquilino ideal</strong> para tu inmueble en tiempo récord',
          icon: 'plus',
        },
        {
          text: '<strong>Acompañamiento en visitas</strong> con agentes certificados',
          icon: 'plus',
        },
        {
          text: '<strong>Elaboración de contrato digital</strong> 100% seguro y fácil de llenar',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>100% del canon mensual</strong> en el segundo mes de contrato', // FIXME: brokerage to agents
          icon: 'currency',
        },
      ],
    },
    aptunoWarranty: {
      friendlyName: 'Garantía Aptuno',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Corretaje Aptuno',
          referencePlanColor: '#F0AE00',
          icon: 'check',
        },
        {
          text: '<strong>Garantía de pago puntual</strong> de renta y admon. hasta 12 meses',
          icon: 'plus',
        },
        {
          text: '<strong>Verificación de perfiles</strong> y estudio de crédito para inquilinos',
          icon: 'plus',
        },
        {
          text: '<strong>Asesoría jurídica</strong> en todo lo relacionado al contrato de arrendamiento',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>50% del valor del canon mensual + administración</strong> + IVA. Descontado del pago del primer mes de contrato',
          icon: 'currency',
        },
      ],
    },
    blueAptuno: {
      friendlyName: 'Aptuno Azul',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Garantía Aptuno',
          referencePlanColor: '#D250E6',
          icon: 'check',
        },
        {
          text: '<strong>Gestión de reparaciones</strong> y mantenimiento del inmueble',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>67% del valor del canon mensual + administración</strong> + IVA. Descontado del pago del primer mes de contrato',
          icon: 'currency',
        },
      ],
    },
    aptunoPlus: {
      friendlyName: 'Aptuno Plus',
      includes: [
        {
          text: 'Todo lo que incluye el plan',
          referencePlanText: 'Aptuno Azul',
          referencePlanColor: '#0055FB',
          icon: 'check',
        },
        {
          text: '<strong>Garantía de pago puntual</strong> de renta y admon. hasta 36 meses',
          icon: 'plus',
        },
        {
          text: '<strong>Posición privilegiada</strong> de tu inmueble en aptuno y portales aliados',
          icon: 'plus',
        },
      ],
      price: [
        {
          text: '<strong>83% del valor del canon mensual + administración</strong> + IVA. Descontado del pago del primer mes de contrato',
          icon: 'currency',
        },
      ],
    },
  },
  chatBotAgentId: 'ec1c54de-f1ea-4aff-826a-776a21e8f0c4',
  capturingAgent: {
    bucketUploadDocument: 'capturing-agent-co',
  },
  gtmId: process.env.GTM_ID || '',
};
